import { render } from "./customer-report.vue?vue&type=template&id=3b80e070&scoped=true"
import script from "./customer-report.vue?vue&type=script&lang=js"
export * from "./customer-report.vue?vue&type=script&lang=js"

import "./customer-report.vue?vue&type=style&index=0&id=3b80e070&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b80e070"]])

export default __exports__